import { DateTime } from "luxon";

export class DatetimeUtils {
    static UTC_TIME_ZONE = 'utc';
    static TIME_ZONE = 'Asia/Manila';

    static getManilaTime(): DateTime {
        return DateTime.now().setZone(this.TIME_ZONE);
    }
}
